import { render, staticRenderFns } from "./DomainDnssecDialog.vue?vue&type=template&id=3b6f0f3a&scoped=true&"
import script from "./DomainDnssecDialog.vue?vue&type=script&lang=js&"
export * from "./DomainDnssecDialog.vue?vue&type=script&lang=js&"
import style0 from "./DomainDnssecDialog.vue?vue&type=style&index=0&id=3b6f0f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6f0f3a",
  null
  
)

/* custom blocks */
import block0 from "./DomainDnssecDialog.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardText,VCol,VContainer,VRow,VSwitch,VTextField,VTextarea})
